import { defineComponent as _defineComponent } from 'vue'
import LegacyArticle from '@/features/editorial/components/article/legacy/LegacyArticle.vue';
import EditorialArticle from '@/features/editorial/components/article/EditorialArticle.vue';
import AppFooter from '@/components/footer/AppFooter.vue';

import { useEditorialArticle } from '@/features/editorial/composables/useEditorialArticle';


export default /*#__PURE__*/_defineComponent({
  __name: 'GuideArticle',
  setup(__props) {

const { isLegacy } = useEditorialArticle();

return { __sfc: true,isLegacy, LegacyArticle, EditorialArticle, AppFooter }
}

})